import { render, staticRenderFns } from "./WideSingleProposal.vue?vue&type=template&id=5496f38e&scoped=true&"
import script from "./WideSingleProposal.vue?vue&type=script&lang=js&"
export * from "./WideSingleProposal.vue?vue&type=script&lang=js&"
import style0 from "./WideSingleProposal.vue?vue&type=style&index=0&id=5496f38e&prod&lang=scss&"
import style1 from "./WideSingleProposal.vue?vue&type=style&index=1&id=5496f38e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496f38e",
  null
  
)

export default component.exports